<div [hidden]="!loading">
  <div
    *ngIf="showMessage"
    class="d-flex justify-content-center alert alert-primary background-primary"
  >
    &nbsp;
    <span>{{ message }} ...</span>
  </div>

  <div class="loader-block">
    <div class="preloader6"><hr /></div>
  </div>
</div>
